import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const Agriculture = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M5.5 27H1V9.4L10 5L19 9.4V27H14.5M5.5 27V16.7333H14.5V27M5.5 27H14.5M25 18.2V22.6M25 18.2H19M25 18.2H31M25 22.6V27M25 22.6H19M25 22.6H31", stroke: "#2B2B2B", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default Agriculture;
